import { __assign } from "tslib";
import { ButtonGroup, FormControl, InputGroup } from 'react-bootstrap';
import { Editor } from 'slate';
import { useSlate } from 'slate-react';
import { ButtonColor, ButtonConfig, InputNumber } from '@victorequena22/component-bootstrap';
import { isBlockProps } from './BlockProps';
import { fontsFamily } from './FontsFamily';
import React from 'react';
export var toggleMark = function (editor, format) {
    var isActive = isMarkActive(editor, format);
    if (isActive) {
        Editor.removeMark(editor, format);
    }
    else {
        Editor.addMark(editor, format, true);
    }
};
var getFontSize = function (editor) {
    if (isBlockProps(editor, 'type', 'heading-one'))
        return 26;
    if (isBlockProps(editor, 'type', 'heading-two'))
        return 22;
    if (isBlockProps(editor, 'type', 'heading-tre'))
        return 18;
    if (isBlockProps(editor, 'type', 'heading-for'))
        return 14;
    return 10;
};
var isMarkActive = function (editor, format) {
    var marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
};
export var MarkButton = function (_a) {
    var format = _a.format, icon = _a.icon, tip = _a.tip;
    var editor = useSlate();
    return (React.createElement(ButtonConfig, { icon: icon, tip: tip, active: isMarkActive(editor, format), action: function () { return toggleMark(editor, format); } }));
};
export var ColorButton = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 2 : _b, colores = _a.colores;
    var editor = useSlate();
    var marks = Editor.marks(editor);
    var is = marks !== null && marks.color !== undefined;
    var color = is ? marks.color : '#000000';
    var style = { width: 32, height: 24, margin: '0 0 0 0', padding: '.25rem .5rem .25rem .5rem' };
    return (React.createElement(ButtonColor, { colores: colores, className: "ml-".concat(left), tip: 'COLOR DE TEXTO', style: style, color: color, invert: true, setData: function (color) { return Editor.addMark(editor, 'color', color); }, click: function () { return (is ? Editor.addMark(editor, 'color', 'currentColor') : Editor.addMark(editor, 'color', color)); } },
        React.createElement("i", { className: 'fas fa-font' })));
};
export var BackButton = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 2 : _b, colores = _a.colores;
    var editor = useSlate();
    var marks = Editor.marks(editor);
    var is = marks !== null && marks.backgroundColor !== undefined;
    var color = is ? marks.backgroundColor : '#00000000';
    var style = { width: 32, height: 24, margin: '0 0 0 0', padding: '.25rem .5rem .25rem .5rem' };
    return (React.createElement(ButtonColor, { colores: colores, className: "ml-".concat(left), tip: 'RESALTAR TEXTO', style: style, color: color, setData: function (backgroundColor) { return Editor.addMark(editor, 'backgroundColor', backgroundColor); }, click: function () {
            return is ? Editor.addMark(editor, 'backgroundColor', '#00000000') : Editor.addMark(editor, 'backgroundColor', color);
        } },
        React.createElement("i", { className: 'fas fa-paint-roller' })));
};
export var FontsFamily = function () {
    var editor = useSlate();
    var marks = Editor.marks(editor);
    var is = marks !== null && marks.fontFamily !== undefined;
    var fontFamily = is ? marks.fontFamily : 'Arial';
    var set = function (e) { return Editor.addMark(editor, 'fontFamily', e.currentTarget.value); };
    return (React.createElement(FormControl, { "data-tip": 'ESTILO DE FUENTE', style: { fontFamily: fontFamily, height: '24px', borderRadius: '.25rem 0 0 .25rem', padding: '0 0 0 0' }, className: 'form-control-sm', as: 'select', onChange: set, value: fontFamily }, fontsFamily.map(function (c, i) { return (React.createElement("option", { style: { fontFamily: c }, key: "fuente".concat(i) }, c)); })));
};
export var FontSize = function () {
    var editor = useSlate();
    var marks = Editor.marks(editor);
    var is = marks !== null && marks.fontSize !== undefined;
    var fontSize = is ? marks.fontSize : getFontSize(editor);
    return (React.createElement(InputNumber, { "data-tip": 'TAMA\u00D1O DE FUENTE', decimal: 0, style: { borderRadius: '0 .25rem .25rem 0', height: 24 }, value: fontSize, setData: function (s) { return Editor.addMark(editor, 'fontSize', s); } }));
};
export var FontStyle = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 2 : _b, _c = _a.width, width = _c === void 0 ? '290px' : _c;
    var s = { height: 24 };
    return (React.createElement(InputGroup, { className: "m-0 p-0 ml-".concat(left), style: __assign(__assign({}, s), { width: width }) },
        React.createElement(InputGroup.Prepend, { style: __assign(__assign({}, s), { width: 'calc(100% - 60px)' }) },
            React.createElement(FontsFamily, null)),
        React.createElement(InputGroup.Append, { style: __assign(__assign({}, s), { width: '60px' }) },
            React.createElement(FontSize, null))));
};
export var MarkMenu = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 0 : _b;
    return (React.createElement(ButtonGroup, { className: "ml-".concat(left) },
        React.createElement(MarkButton, { tip: 'NEGRITAS', format: 'bold', icon: ' fas fa-bold' }),
        React.createElement(MarkButton, { tip: 'CURSIVA', format: 'italic', icon: 'fas fa-italic' }),
        React.createElement(MarkButton, { tip: 'SUBRRAYADO', format: 'underline', icon: 'fas fa-underline' })));
};
//# sourceMappingURL=MarkProps.js.map